"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const framer_motion_1 = require("framer-motion");
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const components_1 = require("./components");
const ModalContent_1 = require("./ModalContent");
const Form_1 = require("../Form");
const nextModalIndex = (() => {
    let index = 0;
    return () => index++;
})();
const defaultOptions = {
    closeOnBackgroundClick: false,
    showCloseButton: true,
};
function Modal({ className, title = '', children, open = true, onClose, onSubmit, buttons, footer, CloseIcon, parameter, onMouseOut, onMouseOver, options: { closeOnBackgroundClick = !!onClose, showCloseButton = !!onClose, } = defaultOptions, aggregateProps, prerender, }) {
    const prerendered = (0, react_1.useRef)(false);
    const { hasParam, removeParam } = (0, app_1.useRouter)();
    const isOpen = parameter ? hasParam(parameter) : open;
    const handleClose = (0, react_1.useMemo)(() => parameter
        ? () => {
            onClose === null || onClose === void 0 ? void 0 : onClose();
            void removeParam(parameter);
        }
        : onClose, [onClose, parameter, removeParam]);
    const onBackgroundClick = (closeOnBackgroundClick !== null && closeOnBackgroundClick !== void 0 ? closeOnBackgroundClick : Boolean(handleClose)) ? handleClose : undefined;
    const closeButton = Boolean(showCloseButton !== null && showCloseButton !== void 0 ? showCloseButton : Boolean(handleClose));
    const hasHeader = Boolean(title) || closeButton;
    const hasFooter = Boolean(buttons === null || buttons === void 0 ? void 0 : buttons.length) || Boolean(footer);
    const Content = (0, react_1.useMemo)(() => ((0, jsx_runtime_1.jsx)(ModalContent_1.ModalContent, Object.assign({ className: className, title: title, open: open, closeIcon: CloseIcon, onMouseOut: onMouseOut, onMouseOver: onMouseOver, footer: footer, buttons: buttons, hasHeader: hasHeader, hasFooter: hasFooter, closeButton: closeButton, handleClose: handleClose }, { children: children }))), [
        CloseIcon,
        buttons,
        children,
        className,
        closeButton,
        footer,
        handleClose,
        hasFooter,
        hasHeader,
        onMouseOut,
        onMouseOver,
        open,
        title,
    ]);
    (0, react_1.useEffect)(() => {
        if (prerender && !prerendered.current) {
            prerendered.current = true;
        }
    }, [prerender]);
    const isPrerendering = prerender && !prerendered.current;
    const index = (0, react_1.useRef)(0);
    const isShown = isOpen || isPrerendering;
    const justAppeared = !(0, app_1.usePreviousValue)(isShown) && isShown;
    if (justAppeared) {
        index.current = nextModalIndex();
    }
    return typeof document === 'undefined'
        ? null
        : (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, Object.assign({ mode: "wait" }, { children: (isOpen || isPrerendering) && ((0, jsx_runtime_1.jsx)(components_1.StyledModalOverlay, Object.assign({ "$index": index.current, onMouseDown: onBackgroundClick, initial: isPrerendering ? 'hiddenPrerender' : 'hidden', animate: isPrerendering ? 'hidden' : 'visible', transition: { duration: 0.2, ease: 'easeInOut' }, exit: "exit", variants: {
                    hidden: { opacity: 0 },
                    hiddenPrerender: { opacity: 0, display: 'none' },
                    visible: { opacity: 1, display: 'flex' },
                    exit: { opacity: 0 },
                } }, { children: onSubmit ? ((0, jsx_runtime_1.jsx)(Form_1.Form, Object.assign({ onSubmit: onSubmit, contextOnly: true }, { children: Content }))) : aggregateProps ? ((0, jsx_runtime_1.jsx)(Form_1.AggregateData, Object.assign({ keepRegistered: true }, aggregateProps, { children: Content }))) : (Content) }))) })), document.body);
}
exports.Modal = Modal;
